export const QUERY_GET_MATERIAL_COLUMN_CONFIG = `
  GetSavedMaterialColumnHeaders($where: project_users_bool_exp) {
    project_users(where: $where) {
      project_id
      material_column_config
    }
  }
`;
